<template>
    <div class="header">
        <div class="header_nav">
            <!--头部左侧-->
            <div class="header_nav_left">
                <div class="header_nav_logo">
                    <router-link to="/">
                        <svg t="1606201263811" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12025" width="45" height="45"><path d="M883.170163 481.367521H110.993007" fill="#135890" p-id="12026"></path><path d="M110.993007 357.246309h772.177156v19.095571H110.993007z" fill="#135890" p-id="12027"></path><path d="M110.993007 376.34188h772.177156v19.095571H110.993007z" fill="#135890" p-id="12028"></path><path d="M110.993007 395.437451h772.177156v19.095572H110.993007z" fill="#135890" p-id="12029"></path><path d="M110.993007 414.533023h772.177156v19.095571H110.993007z" fill="#135890" p-id="12030"></path><path d="M110.993007 433.628594h772.177156v19.095571H110.993007z" fill="#135890" p-id="12031"></path><path d="M110.993007 452.724165h772.177156v19.095571H110.993007z" fill="#135890" p-id="12032"></path><path d="M110.993007 471.819736h772.177156v19.095571H110.993007z" fill="#135890" p-id="12033"></path><path d="M110.993007 490.915307h772.177156v19.095571H110.993007z" fill="#135890" p-id="12034"></path><path d="M110.993007 510.010878h772.177156v19.095571H110.993007z" fill="#135890" p-id="12035"></path><path d="M110.993007 529.106449h772.177156v19.095571H110.993007z" fill="#135890" p-id="12036"></path><path d="M110.993007 548.20202h772.177156v19.095571H110.993007zM110.993007 586.393162h772.177156v19.095571H110.993007z" fill="#135890" p-id="12037"></path><path d="M110.993007 567.297591h772.177156v19.095571H110.993007z" fill="#135890" p-id="12038"></path><path d="M200.503497 0v1024" fill="#135890" p-id="12039"></path><path d="M76.382284 0h19.095571v1024H76.382284z" fill="#135890" p-id="12040"></path><path d="M95.477855 0h19.095572v1024H95.477855z" fill="#135890" p-id="12041"></path><path d="M114.573427 0h19.095571v1024H114.573427z" fill="#135890" p-id="12042"></path><path d="M133.668998 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12043"></path><path d="M152.764569 0H171.86014v1024h-19.095571z" fill="#135890" p-id="12044"></path><path d="M171.86014 0h19.095571v1024H171.86014z" fill="#135890" p-id="12045"></path><path d="M190.955711 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12046"></path><path d="M210.051282 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12047"></path><path d="M229.146853 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12048"></path><path d="M248.242424 0H267.337995v1024h-19.095571z" fill="#135890" p-id="12049"></path><path d="M267.337995 0h19.095571v1024H267.337995zM305.529138 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12050"></path><path d="M286.433566 0h19.095572v1024h-19.095572z" fill="#135890" p-id="12051"></path><path d="M823.496503 0v1024" fill="#135890" p-id="12052"></path><path d="M699.375291 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12053"></path><path d="M718.470862 0h19.095572v1024h-19.095572z" fill="#135890" p-id="12054"></path><path d="M737.566434 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12055"></path><path d="M756.662005 0h19.095571v1024H756.662005z" fill="#135890" p-id="12056"></path><path d="M775.757576 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12057"></path><path d="M794.853147 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12058"></path><path d="M813.948718 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12059"></path><path d="M833.044289 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12060"></path><path d="M852.13986 0h19.095571v1024H852.13986z" fill="#135890" p-id="12061"></path><path d="M871.235431 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12062"></path><path d="M890.331002 0h19.095571v1024h-19.095571zM928.522145 0h19.095571v1024h-19.095571z" fill="#135890" p-id="12063"></path><path d="M909.426573 0h19.095572v1024h-19.095572z" fill="#135890" p-id="12064"></path></svg>
                        <!--<img src="../assets/logo.png"/>-->
                    </router-link>
                </div>
                <!--搜索框-->
                <div>
                    <div class="search">
                        <el-input class="search_input" v-model="search_input" placeholder="请输入要搜索的内容"></el-input>
                        <el-button class="search_button" @click="search" slot="append" icon="el-icon-search"></el-button>
                    </div>
                </div>
            </div>

            <!--头部中间-->
            <div>
                <ul class="header_mid_list">
                    <!--首页-->
                    <router-link :to="'/index'">
                        <li :class="nav_id===1?'header_nav_tab_ul-active':''" @click="getNavId(1)">
                            <svg t="1606193494940" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3028" width="20" height="20"><path d="M853.796053 343.68L512.46272 95.402667 171.129387 343.658667V896a42.666667 42.666667 0 0 0 42.666666 42.666667h128v-170.666667a128 128 0 0 1 128-128h85.333334a128 128 0 0 1 128 128v256h-42.666667a42.666667 42.666667 0 0 1-42.666667-42.666667V768a42.666667 42.666667 0 0 0-42.666666-42.666667h-85.333334a42.666667 42.666667 0 0 0-42.666666 42.666667v213.333333a42.666667 42.666667 0 0 1-42.666667 42.666667h-170.666667a128 128 0 0 1-128-128V405.717333l-17.578666 12.8a42.666667 42.666667 0 1 1-50.176-69.013333l469.333333-341.333333a42.666667 42.666667 0 0 1 50.176 0l469.333333 341.333333a42.666667 42.666667 0 1 1-50.176 68.992L939.129387 405.717333V896a128 128 0 0 1-128 128h-128v-85.333333h128a42.666667 42.666667 0 0 0 42.666666-42.666667V343.68z" fill="#9099B0" p-id="3029"></path></svg>
                        </li>
                    </router-link>
                    <!--文章-->
                    <router-link :to="'/article/rootColumn/:rootColumnId'">
                        <li :class="nav_id===2?'header_nav_tab_ul-active':''" @click="getNavId(2)">
                            <svg t="1606193627193" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3767" width="20" height="20"><path d="M765.79 870.43H258.21c-47.46 0-86.07-38.61-86.07-86.07V273.61c0-45.71 37.19-82.9 82.9-82.9h510.75c47.46 0 86.07 38.61 86.07 86.07v507.57c0 47.47-38.61 86.08-86.07 86.08zM255.04 245.98c-15.24 0-27.63 12.4-27.63 27.63v510.75c0 16.98 13.82 30.81 30.81 30.81h507.57c16.98 0 30.81-13.82 30.81-30.81V276.78c0-16.98-13.82-30.81-30.81-30.81H255.04z" p-id="3768"></path><path d="M663.3 452.05H362.02c-15.26 0-27.63-12.37-27.63-27.63s12.37-27.63 27.63-27.63H663.3c15.26 0 27.63 12.37 27.63 27.63s-12.37 27.63-27.63 27.63zM574.71 615.6H362.02c-15.26 0-27.63-12.37-27.63-27.63s12.37-27.63 27.63-27.63h212.69c15.26 0 27.63 12.37 27.63 27.63s-12.37 27.63-27.63 27.63z" p-id="3769"></path></svg>
                        </li>
                    </router-link>
                    <!--聊天-->
<!--                    <router-link :to="'/chat'">-->
<!--                        <li :class="nav_id===3?'header_nav_tab_ul-active':''" @click="getNavId(3)">-->
<!--                            <svg t="1606193721768" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5124" width="20" height="20"><path d="M511.575104 936.471369c-18.695436 0-36.965975-7.223237-52.262241-21.669709l-0.424896-0.424897L350.539419 809.00249H172.082988c-46.738589 0-84.979253-38.240664-84.979254-84.979253V169.958506c0-46.738589 38.240664-84.979253 84.979254-84.979253h679.834024c46.738589 0 84.979253 38.240664 84.979254 84.979253v554.064731c0 46.738589-38.240664 84.979253-84.979254 84.979253h-178.456431l-110.048133 106.224066c-15.296266 14.446473-33.566805 21.244813-51.837344 21.244813z m-8.922822-67.983402c5.948548 5.523651 11.472199 5.523651 17.420747 0l127.46888-123.219917h203.950207c11.897095 0 21.244813-9.347718 21.244813-21.244813V169.958506c0-11.897095-9.347718-21.244813-21.244813-21.244813H172.082988c-11.897095 0-21.244813 9.347718-21.244814 21.244813v554.064731c0 11.897095 9.347718 21.244813 21.244814 21.244813h204.375103l126.194191 123.219917z" p-id="5125"></path></svg>-->
<!--                        </li>-->
<!--                    </router-link>-->
                    <!--chatGPT聊天-->
<!--                    <router-link :to="'/chatGPT'">-->
<!--                      <li :class="nav_id===5?'header_nav_tab_ul-active':''" @click="getNavId(5)">-->
<!--                        <svg t="1738740500838" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6613" width="20" height="20"><path d="M432.69444566 74.05914392c-20.04523218 3.27662441-45.48725812 11.37181406-65.72523315 21.20168728-50.30582334 24.47831173-88.85434501 66.30345974-109.47780574 119.30767903l-4.04759384 10.21535891-16.38312209 4.81856524C120.64415058 263.13964993 52.6060072 386.68766562 86.14322273 503.87517531c6.36050602 22.55088525 21.39443015 52.61873357 35.65738297 71.70025347l12.14278536 15.99763644-4.43307952 17.34683625c-5.58953655 21.97265867-7.51696113 55.89535799-4.43308146 78.63898608 12.1427854 90.20354299 77.48253097 164.40945141 164.98767997 187.34582239 23.7073423 6.36050602 61.48489455 8.48067532 85.57772057 5.01130804l15.8048936-2.3129121 14.07021188 13.2992405c17.73232004 16.76860779 32.7662442 27.17670954 55.70261514 37.97029508 81.14464107 38.93400736 178.47966138 24.47831173 245.55409249-36.42835431 22.55088525-20.62346069 44.90902958-53.00421922 55.31712949-80.3736697l5.58953657-14.26295469 15.61215266-4.43307956c20.23797502-5.58953655 54.54616002-22.35814242 71.50750872-35.27189916 50.11308049-37.97029508 81.14464107-93.67291024 87.89063276-158.04894354 5.78227938-55.31713137-12.91375483-116.03105457-49.53485203-160.74734132l-6.36050596-7.70970398 3.85485291-13.49198334c12.52826917-45.2945153 8.28793247-98.68421829-11.56455687-143.78599073C843.62169993 193.55956574 764.59722818 141.51905878 677.09208113 141.51905878c-12.52826917 0-28.33316466 0.96371229-34.8864135 1.92742648l-12.33552825 2.1201693-14.07020997-13.29924052C586.31030961 104.1269922 551.23115328 85.62370081 510.1769766 76.75753984 493.6011117 73.09542972 448.88482491 71.55348895 432.69444566 74.05914392z m73.24219235 60.71392318c23.1291138 6.36050602 65.72523125 29.68236263 61.48489456 33.7299584-0.96371229 0.96371229-41.24691952 24.28556889-89.43257353 52.04050504-48.18565403 27.947679-90.78177149 53.58244775-94.44388159 57.05181501l-6.74599169 6.55324887-0.57822659 129.13755224c-0.19274285 71.12202496-0.77097134 129.13755225-1.15645705 129.13755224-0.5782285 0-17.34683629-9.63713041-37.77755223-21.39443014l-36.81384-21.39443017 0.57822853-117.95848103c0.77097134-116.22379741 0.77097134-117.95848105 5.01130804-132.22143384 9.82987325-31.8025319 30.64607491-63.41232101 54.93164571-82.87932469 16.76860779-13.68472618 47.22193983-28.33316466 68.23088622-32.95898702 20.43071786-4.43307953 58.01552725-3.85485293 76.71155962 1.15645509z m212.01687696 69.1945985c18.11780571 4.81856519 48.76388255 21.00894449 63.79780665 33.7299584 24.47831173 20.43071786 44.33080109 51.84776415 53.00421922 84.22852265 3.27662441 11.5645569 4.24033671 21.20168733 4.43307957 40.668691 0.19274285 13.87746902-0.38548567 25.8275097-0.96371419 26.40573819-0.77097134 0.77097134-42.78886029-22.74362809-93.4801674-52.04050507-84.0357798-48.57113972-93.09468362-53.3897049-101.18987326-53.5824477-8.09518964 0-17.34683629 4.81856519-113.71814241 60.52118222-57.6300416 33.34447269-106.77940791 61.6776374-109.28506292 63.2195782l-4.24033859 2.89113873 0.38548566-43.94531731 0.57822853-43.75257261 84.80675116-49.1493663c107.16489358-62.06312113 116.03105457-66.49620258 141.85856425-71.8929963 13.10649767-2.69839589 60.52118037-0.96371229 74.01316373 2.6983959zM247.85427632 512.74133627c2.50565306 3.46936727 43.75257451 28.33316466 111.79071789 67.6526577 59.1719824 34.30818501 107.93586494 63.02683534 108.12860586 63.7978048 0.5782285 1.15645513-66.88168826 41.05417667-71.70025156 42.40337654-2.1201693 0.5782285-175.78126547-99.06970398-190.62244679-109.2850629C154.1813661 541.84547038 127.00465657 476.69846576 137.60550117 415.21357313c9.25164475-53.00421922 43.9453154-98.68421829 92.32371227-121.62059117l11.95004259-5.58953463 0.96371226 109.67054665c0.96371229 107.35763642 0.96371229 109.86329139 5.01130803 115.06734229z m467.59358558-126.24641349c109.09232005 63.02683534 105.43020994 60.71392321 123.93350133 79.60270027 77.67527379 79.60270026 55.12438853 210.86042183-44.71628676 261.16624323-6.55324886 3.27662441-12.91375483 5.97502035-13.87746901 5.97502034-1.34919796 0-2.1201693-37.58480941-2.50565309-108.70683437-0.5782285-106.77940791-0.5782285-108.89957722-4.62582427-114.29637096-2.50565306-3.46936727-42.21063179-27.5621933-112.17620163-68.03814338-59.55746805-34.30818501-108.12860778-63.21957817-107.74312211-64.18329045 0.5782285-2.1201693 69.00185567-41.63240517 72.08573917-41.82514802 1.34919796 0 41.63240517 22.74362809 89.62531637 50.30582334z m-157.47071694 42.40337464l47.22193983 27.36945236v110.24877517l-45.87274189 26.40573821c-25.05654023 14.45569565-46.64371323 26.59848103-47.6074255 26.98396672-1.15645513 0.38548567-23.1291138-11.5645569-48.76388253-26.40573823l-46.64371323-26.9839667v-110.24877517l46.83645607-27.17670956c25.63476877-15.03392415 46.83645605-27.17670954 47.02919889-27.36945046 0.38548567 0 21.77991583 12.33552825 47.80016836 27.17670766z m125.66818501 72.85670855l36.23561144 20.81620357 0.57822852 108.70683436c0.19274285 69.77282701-0.19274285 113.52539958-1.54194078 122.00607494-2.89113873 18.50329138-10.21535894 39.89772155-19.85248935 57.05181501-10.79358555 19.08151803-39.70497872 48.57113972-58.20827015 59.17198235-42.98160314 24.67105456-89.43257355 30.0678483-133.95611746 15.61215266-15.41940981-5.01130803-34.69367068-14.45569565-46.0654847-22.74363-6.93873452-5.20405088-7.90244679-6.55324886-5.7822794-8.67341624 1.5419408-1.34919796 42.21063179-25.24928306 90.39628582-53.00421922s89.23983071-51.84776415 91.35999998-53.58244775c8.86616096-7.90244679 8.86616096-8.48067532 8.86616095-141.08759482 0-68.80911282 0.38548567-125.28269933 0.77096949-125.2826993 0.5782285 0 17.15409345 9.44438757 37.19932564 21.00894444zM605.19908479 656.72006982v43.17434598L537.35368427 739.02116603c-37.39206656 21.587173-80.56641258 46.45097039-95.98582239 55.31713135-17.34683629 10.02261611-34.8864135 18.50329138-46.25822755 22.1653996-17.34683629 5.78227938-19.85248938 6.16776318-48.18565403 6.16776319-35.27189918 0.19274285-45.2945153-2.1201693-74.20590655-16.19037928-48.37839686-23.7073423-80.95189822-68.23088623-89.62531637-122.19881775-2.31291214-13.87746902-1.92742646-47.99291119 0.38548568-50.49856426 0.77097134-0.5782285 40.09046439 21.39443015 87.6978899 48.95662347 103.88826916 59.94295374 96.75679372 56.28084366 107.16489358 56.28084368 9.25164475 0-1.15645513 5.58953655 153.42312306-83.65029415 39.70497872-22.93637095 72.47122291-41.63240517 72.8567086-41.63240517 0.38548567 0 0.5782285 19.46700369 0.57822659 42.98160312z" p-id="6614"></path></svg>-->
<!--                      </li>-->
<!--                    </router-link>-->
<!--                    &lt;!&ndash;媒体&ndash;&gt;-->
<!--                    <router-link :to="'/media'">-->
<!--                        <li :class="nav_id===4?'header_nav_tab_ul-active':''" @click="getNavId(4)">-->
<!--                            <svg t="1606221259968" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3063" width="20" height="20"><path d="M941.511111 839.111111c-28.444444 19.911111-105.244444 45.511111-429.511111 45.511111-347.022222 0-398.222222-31.288889-415.288889-39.822222C11.377778 790.755556 0 580.266667 0 517.688889c0-48.355556 8.533333-284.444444 96.711111-338.488889C113.777778 170.666667 164.977778 139.377778 512 139.377778c324.266667 0 401.066667 25.6 429.511111 48.355555 76.8 56.888889 82.488889 267.377778 82.488889 329.955556 0 76.8-8.533333 264.533333-82.488889 321.422222zM890.311111 244.622222c-22.755556-14.222222-73.955556-34.133333-384-34.133333-298.666667 0-361.244444 22.755556-372.622222 31.288889-28.444444 17.066667-62.577778 142.222222-65.422222 287.288889 2.844444 145.066667 34.133333 224.711111 65.422222 244.622222 11.377778 5.688889 73.955556 31.288889 372.622222 31.288889 310.044444 0 372.622222-25.6 384-34.133334 25.6-19.911111 54.044444-93.866667 56.888889-241.777777 0-147.911111-31.288889-270.222222-56.888889-284.444445zM401.066667 682.666667c-8.533333 5.688889-19.911111 5.688889-28.444445 0-8.533333-5.688889-14.222222-14.222222-14.222222-22.755556V366.933333c0-8.533333 5.688889-19.911111 14.222222-22.755555 8.533333-5.688889 19.911111-5.688889 28.444445 0l250.311111 147.911111c11.377778 5.688889 17.066667 22.755556 11.377778 34.133333-2.844444 5.688889-5.688889 8.533333-11.377778 11.377778L401.066667 682.666667z" fill="#666666" p-id="3064"></path></svg>-->
<!--                        </li>-->
<!--                    </router-link>-->
                    <!--跳转到易经项目iching-->
<!--                    <li @click="goToUrl('iching')">-->
<!--                      <svg t="1738740343359" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5305" width="20" height="20"><path d="M436.163 143.513c-42.596 8.659-52.15 15.625-52.15 41.601 0 21.696 0.895 21.696 45.98 15.625 60.808-9.554 213.677-6.07 240.548 5.275 30.355 11.346 42.597 33.938 48.667 88.576 6.967 60.81-12.141 84.197-67.676 84.197-20.9 0.896-82.505 2.588-138.935 4.38-126.793 4.379-132.068 0-133.76-95.543-0.896-34.734-3.384-66.88-6.966-72.951-9.555-15.625-38.218-11.246-48.668 6.966-9.554 19.109-11.345 101.614-1.691 148.49 10.35 54.638 29.558 72.155 84.197 76.434 40.804 3.384 46.875 6.071 37.321 16.521-24.284 29.559-108.58 63.397-159.736 63.397-40.904 0-59.913 16.52-51.254 43.392 8.658 27.767 64.292 24.284 164.114-11.246 33.042-12.242 106.79-70.363 125.102-99.822 14.73-22.592 16.52-23.389 101.613-22.592 105.894 0.895 138.936-9.555 156.352-52.15 15.626-37.322 16.521-61.606 3.484-115.448-21.796-90.467-33.838-103.406-107.685-122.514-39.212-10.45-191.981-12.142-238.857-2.588z m-1.792 128.485c-4.379 6.071-6.966 17.318-5.274 25.976 2.587 13.933 13.933 15.625 111.168 15.625l108.58-0.895 2.588-23.388c3.483-27.768 9.554-25.976-113.756-26.971-64.193-0.697-97.235 2.687-103.306 9.653zM584.652 457.81c-15.625 6.071-19.108 13.038-15.625 29.559 3.483 20.004-6.07 28.663-92.955 85.889-60.81 40.904-115.448 69.467-148.49 79.022-96.438 27.767-114.551 41.7-91.163 69.467C272.944 765.14 434.47 683.53 608.14 533.348c37.321-32.146 70.264-30.355 86.884 3.483 8.659 19.109 17.317 24.284 39.91 24.284 62.5 0 81.609 72.155 36.524 138.139-45.183 65.188-123.31 94.647-178.048 66.88-24.283-13.038-27.767-13.038-32.146-0.896-6.966 16.521 10.35 59.018 32.146 79.022 32.943 29.559 130.178-0.896 199.745-63.397 44.288-39.909 59.017-67.775 63.396-121.518 7.763-97.235-66.88-187.602-166.702-198.849-22.592-2.587-50.36-6.07-62.501-6.966-12.241-1.792-31.45-0.1-42.696 4.28z m36.426 153.765c-117.14 92.855-216.265 148.39-312.604 174.465-56.53 15.625-59.913 70.263-4.38 70.263 33.938 0 131.173-41.7 184.12-79.021 26.871-19.109 55.534-33.938 63.396-33.938 7.763 0 14.73-5.275 14.73-11.346 0-6.966 22.592-31.25 49.563-54.638 80.813-69.468 83.301-72.155 71.259-86.885-13.934-17.217-19.109-15.426-66.084 21.1z" fill="#707070" p-id="5306"></path></svg>-->
<!--                    </li>-->
                </ul>
            </div>

            <!--一级导航栏列表-->
            <div class="header_nav_tab">
                <ul class="header_nav_tab_ul">
                    <li     :class="rootColumnId===item.id?'header_nav_tab_ul-active':''"
                            v-for="(item,index) in rootColumnList" :key="index">
                        <router-link :to="'/rootColumn/' + item.id">
                            <a>{{item.label}}</a>
                        </router-link>
                        <!--1,{{rootColumnId}}-->
                        <!--2,{{item.id}}-->
                        <!--3,{{rootColumnList[0].id}}-->
                    </li>
                </ul>
            </div>

            <!--登录注册，用户头像-->
            <div>
                <div v-if="token==null" class="isNotLogin">
<!--                    <router-link :to="'/login'+'?redirect='+this.router"><a>登录</a></router-link>-->
<!--                    <router-link :to="'/register'"><a>注册</a></router-link>-->
                </div>
                <div v-else class="isLogin">
                    <!--<el-avatar :size="medium" :src="userInfo.circleUrl"></el-avatar>-->
                    <!--有token{{username}}-->
                    <!--{{userInfo.username}}-->
                    <!--<button @click="Logout">退出登录</button>-->

                    <!--用户头像下拉-->
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            <el-avatar :size="40" :src="userInfo.avatar"></el-avatar>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="username">
                                <!--<div><router-link :to="'/user/room'">{{userInfo.username}}</router-link></div>-->
                                个人中心
                                <!--{{userInfo.username}}-->
                            </el-dropdown-item>
                            <el-dropdown-item command="favorite">
                                我的收藏
                            </el-dropdown-item>
                            <el-dropdown-item command="comment">
                                我的评论
                            </el-dropdown-item>
                            <el-dropdown-item command="message">
                                我的消息
                            </el-dropdown-item>
                            <el-dropdown-item command="logout">
                                <!--<div @click="Logout">退出登录</div>-->
                                退出登录
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // import {getRootColumn} from "@/api/get";
    // import {search} from "@/api/search";

    export default {
        name: "Header",
        data() {
            return {
                rootColumnId: 0,
                rootColumnList: [],
                token:"",
                username:"",
                router:"",

                nav_id: 0,

                userInfo: {
                    username:"",
                    avatar: "",
                },

                search_input: ''
            }
        },
        watch: {
            /*监听路由变化*/
            $route:{
                handler(){
                    this.rootColumnId = this.$route.params && this.$route.params.rootColumnId;
                    // this.level1ColumnList = "";
                    // console.log(this.rootColumnId)
                    // this.getLevel1Column()

                    //获取当前路由
                    this.router = this.$route.fullPath;
                    // console.log("router"+this.router)

                },
                immediate: true
            }
        },
        created() {
            this.token = this.$store.state.user.token;
            this.userInfo.username = this.$store.state.user.username;
            this.userInfo.avatar = this.$store.state.user.avatar;
            // this.getRootColumn();
            // this.getUserInfo();
        },
        methods: {
            // getRootColumn(){
            //     getRootColumn().then(response => {
            //         // console.log("这里"+JSON.stringify(response.data))
            //         this.rootColumnList = response.data
            //         // this.rootColumnId = this.rootColumnList[0].id
            //         // console.log(this.rootColumnList)
            //         // for (let i=0; i<this.rootColumnList.length; i++){
            //         //     console.log(this.rootColumnList[i].label)
            //         // }
            //     });
            // },

            //点击头部导航栏
            getNavId(id){
                this.nav_id = id;
            },

            //跳转到iching项目
            goToUrl(url){
                if (url === 'iching'){
                  // window.location.href = "https://iching.204910013.xyz";
                  window.open("https://iching.204910013.xyz", "_blank");
                }
            },

            search(){
                if(this.search_input===""){
                    this.$message({
                        showClose: true,
                        message: "请先输入要搜索的内容",
                        type: 'error'
                    });
                }else {
                    this.$router.push({ path: "/search/"+this.search_input });
                    // search(this.search_input,1,10).then(response => {
                    //     this.$message({
                    //         showClose: true,
                    //         message: response.data,
                    //         type: 'success'
                    //     });
                    //     this.$router.push({ path: "/search?="+this.search_input });
                    // });
                }

            },

            handleCommand(command) {
                if (command==="logout"){
                    // this.$message('click on item ' + command);
                    this.Logout();
                }  else if (command==="favorite") {
                    this.$router.push({ path: "/favorite" });
                }  else if (command==="comment") {
                    this.$router.push({ path: "/comment" });
                }  else if (command==="message") {
                    this.$router.push({ path: "/message" });
                }  else if (command==="username") {
                    // this.$message('click on item ' + command);
                    this.$router.push({ path: "/user/room" });
                }
            },

            // getUserInfo(){
            //     //根据token获取用户信息
            //     this.$store
            //         .dispatch("getUserInfo")
            //         .then(response => {
            //             if (response.code==200){
            //                 // this.$message({
            //                 //     showClose: true,
            //                 //     message: response.msg,
            //                 //     type: 'success'
            //                 // });
            //                 this.userInfo = response.data
            //                 // this.$router.push({ path: this.redirect || "/" });
            //             } else {
            //                 this.$message({
            //                     showClose: true,
            //                     message: response.msg,
            //                     type: 'error'
            //                 });
            //                 this.loading = false;
            //             }
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 showClose: true,
            //                 message: error.msg,
            //                 type: 'error'
            //             });
            //             this.loading = false;
            //             // this.getCode();
            //         });
            // },

            //退出登录
            Logout(){
                this.$store
                    .dispatch("LogOut")
                    .then(res => {
                        if (res.code==200){
                            // console.log("退出"+res)
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'success'
                            });
                            // this.$router.push({ path: this.redirect || "/" });
                            // location.reload();
                            setTimeout(() =>{
                                location.reload();
                            },1000);
                        }else {
                            this.$message({
                                showClose: true,
                                message: "出问题了",
                                type: 'error'
                            });
                        }
                    }).catch(() => {
                        console.log("error")
                    });
            }
        }
    }
</script>

<style scoped>
    .clear-fix{
        display: block;
    }
    .header{
        border-bottom: solid 1px #e6e6e6;
        /*box-shadow: 10px 10px 5px #888888;*/
        /*box-shadow: 0px 20px 20px -20px #5E5E5E;*/
        /*box-shadow: 0 -2px 3px hsla(0, 0%, 7%, .1), 0 0 0 1px hsla(0, 0%, 7%, .1);*/
        height: 70px;
        margin-top: -15px;
        background: #ffffff;
    }
    .header_nav{
        /*width: 80%;*/
        /*margin: 0 auto;*/
        /*display: flex;*/
        /*position: relative;*/
    }
    .header_nav_logo{
        margin-top: 10px;
        margin-left: 16px;
        margin-right: 60px;
        float: left;
    }
    .header_nav_logo img{
        width: 50px;
    }
    .header_nav_tab{
        /*margin-top: 10px;*/
        float: left;
    }
    .header_nav_tab_ul{
        list-style: none;
        display: flex;
        margin-top: 0;
    }

    .header_nav_tab_ul a{
        font-size: 16px;
        color: #000;
        display: inline-block;
        /*margin-right: 26px;*/
        text-align: center;
        list-style: none;
        padding: 12px;
    }
    .header_nav_tab_ul a:hover{
        background: #6495ED;
    }
    .header_nav_tab_ul-active a{
        background: #6495ED;
        color: white;
    }

    /*中间部分*/
    .header_mid_list{
        justify-content: center;
        display: flex;
        list-style: none;
    }
    .header_mid_list li{
        /*color: #2266FF;*/
        /*background: #00BB33;*/
        padding: 16px 60px;
        margin: 10px;
    }
    .header_mid_list li:hover{
        background: #F0F2F5;
        border-radius: 10px;
    }
    .header_nav_tab_ul-active{
        background: #F0F2F5;
        border-radius: 10px;
    }
    /*.header_mid_list{*/
        /*background: #990055;*/
    /*}*/

    /*搜索框*/
    .search{
        position: absolute;
        top: 15px;
        /*right: 150px;*/
        left: 80px;
        display: flex;
    }
    .search_input{
        border: #6495ED 1px solid;
        /*border-radius: 5px;*/
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
    }
    .search_button{
        border: #6495ED 1px solid;
        /*border-radius: 5px;*/
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
    }

    /*用户登录注册，头像部分*/
    .header_nav_user{
        position: absolute;
        top: 25px;
        right: 10px;
    }
    .isNotLogin{
        position: absolute;
        top: 25px;
        right: 10px;
    }
    .isNotLogin a{
        margin-right: 10px;
    }
    .isLogin{
        position: absolute;
        top: 15px;
        right: 10px;
    }
    .header_nav_user a{
        margin-right: 10px;
    }


    .header_nav_right{
        float: right;
    }


    .el-menu.el-menu--horizontal{
        border-bottom: none;
    }

</style>

<!--下拉
    <div class="header_nav_right">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">笔记</el-menu-item>
        <el-submenu index="2">
            <template slot="title">我的工作台</template>
            <el-menu-item index="2-1">选项1</el-menu-item>
            <el-menu-item index="2-2">选项2</el-menu-item>
            <el-menu-item index="2-3">选项3</el-menu-item>
            <el-submenu index="2-4">
                <template slot="title">选项4</template>
                <el-menu-item index="2-4-1">选项1</el-menu-item>
                <el-menu-item index="2-4-2">选项2</el-menu-item>
                <el-menu-item index="2-4-3">选项3</el-menu-item>
            </el-submenu>
        </el-submenu>
        <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item>
    </el-menu>
</div>-->

<!--<template>-->
<!--&lt;!&ndash;顶部&ndash;&gt;-->
<!--<div id="header">-->
    <!--<div class="center-box clear-fix">-->
        <!--<div class="header-logo float-left">-->
            <!--<span>阳光沙滩-券场</span>-->
        <!--</div>-->
        <!--<div class="header-menu float-left">-->
            <!--<ul>-->
                <!--<li class="menu-active"><router-link to="/index"><a>首页</a></router-link></li>-->
                <!--<li><router-link to="/back"><a>后端</a></router-link></li>-->
                <!--<li><router-link to="/front"><a>前端</a></router-link></li>-->
                <!--<li><router-link to="/language"><a>编程语言</a></router-link></li>-->
                <!--<li><router-link to="/program"><a>软件工程</a></router-link></li>-->
                <!--<li><router-link to="/algorithm"><a>算法</a></router-link></li>-->
                <!--<li><router-link to="/room"><a>吹水间</a></router-link></li>-->
                <!--<li><router-link to="/blog"><a>博客</a></router-link></li>-->
            <!--</ul>-->
        <!--</div>-->
        <!--<div class="header-search-box float-left">-->
            <!--<el-input v-model="input" placeholder="复制（淘宝的标题或者关键字）找优惠券!" size="small"></el-input>-->
        <!--</div>-->
        <!--<div class="header-search-btn float-left">-->
            <!--<el-button type="danger" size="small">搜索</el-button>-->
        <!--</div>-->
    <!--</div>-->
<!--</div>-->
<!--</template>-->

<!--<style>-->
    <!--html {-->
        <!--font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;-->
        <!--font-size: 16px;-->
        <!--word-spacing: 1px;-->
        <!-- -ms-text-size-adjust: 100%;-->
        <!-- -webkit-text-size-adjust: 100%;-->
        <!-- -moz-osx-font-smoothing: grayscale;-->
        <!-- -webkit-font-smoothing: antialiased;-->
        <!--box-sizing: border-box;-->
    <!--}-->

    <!--*, *:before, *:after {-->
        <!--box-sizing: border-box;-->
        <!--margin: 0;-->
    <!--}-->

    <!--.menu-active {-->
        <!--background: #0000000a;-->
    <!--}-->

    <!--.header-search-btn {-->
        <!--margin-left: 20px;-->
    <!--}-->

    <!--.header-search-box {-->
        <!--margin-left: 20px;-->
    <!--}-->

    <!--.header-search-box .el-input {-->
        <!--width: 300px;-->
    <!--}-->

    <!--.header-search-btn .el-button&#45;&#45;danger {-->
        <!--width: 100px;-->
    <!--}-->

    <!--.header-search-box, .header-search-btn {-->
        <!--line-height: 70px;-->
    <!--}-->

    <!--#header {-->
        <!--box-shadow: 0px 5px 10px #d4d4d4;-->
        <!--background: #fff;-->
        <!--height: 70px;-->
    <!--}-->

    <!--.float-left {-->
        <!--float: left;-->
    <!--}-->

    <!--.clear-fix {-->
        <!--zoom: 1;-->
        <!--overflow: auto;-->
    <!--}-->


    <!--.header-menu li:hover {-->
        <!--background: #0000000a;-->
    <!--}-->

    <!--.header-menu li {-->
        <!--cursor: pointer;-->
        <!--float: left;-->
        <!--color: #000;-->
        <!--font-size: 16px;-->
        <!--font-weight: 600;-->
        <!--line-height: 70px;-->
        <!--padding-left: 15px;-->
        <!--padding-right: 15px;-->
    <!--}-->

    <!--.header-menu ul {-->
        <!--list-style: none;-->
    <!--}-->

    <!--.header-logo {-->
        <!--font-size: 24px;-->
        <!--line-height: 70px;-->
        <!--font-weight: 600;-->
        <!--color: #c9302c;-->
    <!--}-->

    <!--.center-box {-->
        <!--width: 80%;-->
        <!--margin: 0 auto;-->
    <!--}-->
<!--</style>-->
